import { render } from "./ShowDetailedOrganization.vue?vue&type=template&id=43fe70ca&scoped=true"
import script from "./ShowDetailedOrganization.vue?vue&type=script&lang=js"
export * from "./ShowDetailedOrganization.vue?vue&type=script&lang=js"

import "./ShowDetailedOrganization.vue?vue&type=style&index=0&id=43fe70ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fe70ca"]])

export default __exports__